var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.42,
    height: 21.963,
    viewBox: "0 0 24.42 21.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.572 -658.129)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.627,
    height: 2.349,
    rx: 1.174,
    transform: "translate(260.312 663.174)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.767,700.513h13.752a1.334,1.334,0,0,1,1.45,1.174h0a1.334,1.334,0,0,1-1.45,1.174H264.767a1.334,1.334,0,0,1-1.45-1.174h0A1.334,1.334,0,0,1,264.767,700.513Z",
    transform: "translate(-10.084 -31.193)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.878,715.822H275.22A1.345,1.345,0,0,1,276.687,717h0a1.345,1.345,0,0,1-1.467,1.174H264.878A1.345,1.345,0,0,1,263.411,717h0A1.345,1.345,0,0,1,264.878,715.822Z",
    transform: "translate(-10.153 -42.461)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.572,678.043V660.177c.021-.1.04-.193.064-.289a2.3,2.3,0,0,1,2.266-1.756h18.429c.462,0,.925-.006,1.387,0a2.236,2.236,0,0,1,1.575.65,2.323,2.323,0,0,1,.7,1.743q0,8.251,0,16.5c0,.246,0,.491,0,.737a2.3,2.3,0,0,1-1.758,2.263c-.1.025-.2.043-.3.064H251.622a.265.265,0,0,0-.056-.023,2.264,2.264,0,0,1-1.9-1.641C249.621,678.3,249.6,678.172,249.572,678.043Zm13.736-18.072H252c-.05,0-.1,0-.15,0a.455.455,0,0,0-.418.318.883.883,0,0,0-.023.235q0,8.588,0,17.177a1.1,1.1,0,0,0,.013.186.451.451,0,0,0,.371.357,1.533,1.533,0,0,0,.212.011h19.555c.038,0,.075,0,.112,0a.467.467,0,0,0,.485-.5q0-8.645,0-17.29a.565.565,0,0,0-.016-.148.465.465,0,0,0-.51-.347Z",
    transform: "translate(0 0)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.177,677.533a2.767,2.767,0,1,1,2.771-2.75A2.776,2.776,0,0,1,266.177,677.533Z",
    transform: "translate(-10.153 -10.215)",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/Template.a0ab51779ab76f69704f78e68326d84a.svg";
export { ForwardRef as ReactComponent };